import React from 'react';

const RecentUploadsConfig = {
  settings: {
    layout: {
      config: {
        navbar: {
          display: false,
        },
        toolbar: {
          display: true,
        },
        footer: {
          display: true,
        },
      },
    },
  },
  routes: [
    {
      path: '/recentuploads',
      component: React.lazy(() => import('./RecentUploads')),
    },
  ],
};

export default RecentUploadsConfig;
